// extracted by mini-css-extract-plugin
module.exports = {"message":"_2SGuP3FzOQDoBZV9SZkS0L"};